/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationUserSessionIssuersGet } from "../funcs/organizationUserSessionIssuersGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import {
  GetOrganizationUserSessionIssuerRequest,
  GetOrganizationUserSessionIssuerSecurity,
} from "../models/operations/getorganizationusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationUserSessionIssuerQueryData = UserSessionIssuer;

export function prefetchOrganizationUserSessionIssuer(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationUserSessionIssuerRequest,
  security?: GetOrganizationUserSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationUserSessionIssuerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationUserSessionIssuerQuery(
  client$: GramCore,
  request: GetOrganizationUserSessionIssuerRequest,
  security?: GetOrganizationUserSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationUserSessionIssuerQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuer({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function organizationUserSessionIssuerQueryFn(
      ctx,
    ): Promise<OrganizationUserSessionIssuerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationUserSessionIssuersGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganizationUserSessionIssuer(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "organizationUserSessionIssuers", "get", parameters];
}
